import { numberFormat } from "../number/numberFormat";
import { InputNumber } from "@goodfill/ui-components";

export function NumberRangeFilter({
  value,
  onChange,
  leftIcon,
  small,
}: {
  value: [number | null, number | null];
  onChange: (value: [number | null, number | null]) => void;
  label: string;
  leftIcon?: string;
  small?: boolean;
}) {
  return (
    <div className="flex flex-row">
      <InputNumber
        small={small}
        border="neutral"
        value={value[0] ?? undefined}
        setValue={(left) => onChange([left, value[1]])}
        placeholder={"Min"}
        formatValue={numberFormat}
        leftIcon={leftIcon}
      />
      <InputNumber
        small={small}
        border="neutral"
        value={value[1] ?? undefined}
        setValue={(right) => onChange([value[0], right])}
        placeholder={"Max"}
        formatValue={numberFormat}
        leftIcon={leftIcon}
      />
    </div>
  );
}
